import { Modal } from 'antd'

import Styles from './UpdateBlazePaymentMethodModal.module.scss'

import { Spinner } from 'common/Spinner/Spinner'
import { Button } from 'components/Button'
import { useStripePaymentMethodUpdate } from 'hooks/useStripePaymentMethodUpdate'
import { useModals } from 'almanac-ui/Modal'
import { UpgradePlanModal } from 'components/Paywall/UpgradePlanModal/UpgradePlanModal'
import { useState } from 'react'

export const UpdateBlazePaymentMethodModal = () => {
  const { isProcessing, redirectToStripe } = useStripePaymentMethodUpdate()
  const [hideMainModal, setHideMainModal] = useState(false)
  const { openModal, closeModal } = useModals()

  const cancelSubscription = () => {
    setHideMainModal(true)

    openModal(UpgradePlanModal, { initialPage: 'provideReason', onClose: closeModal, showSuccessModal: false })
  }

  if (hideMainModal) return null

  return (
    <Modal
      visible={true}
      footer={null}
      closable={false}
      width={'fit-content'}
      wrapClassName={Styles.antModalOverrides}
      onCancel={() => {}}
    >
      <div className={Styles.container}>
        <div className={Styles.messageContainer}>
          <p className={Styles.title}>There was an issue with your payment method</p>
          <p className={Styles.subTitle}>We encountered an error processing your payment method. Please try again.</p>
        </div>
        <div className={Styles.buttonContainer}>
          <Button variant="tertiary" size="lg" onPress={cancelSubscription}>
            Cancel Subscription
          </Button>
          <Button isDisabled={isProcessing} onPress={redirectToStripe} size="lg">
            {isProcessing && <Spinner className={Styles.loadingSpinner} />}
            Set Up Payment
          </Button>
        </div>
      </div>
    </Modal>
  )
}
